module.exports = __webpack_public_path__ + "static/media/running-man-background-icon.3f99d786.svg";